import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import * as Yup from "yup";
// images
import { Col, Container, Row } from "react-bootstrap";
import crose from "../../../assets/images/icons/crose.svg";
import { memberProfileAction } from "../actions";
import AddTaskForm from "./todo";
import SubmitLoader from "../../../components/SubmitLoader";
import CustomButton from "../../../components/Buttons/CustomButton";

const validationSchema = Yup.object({
  credentials: Yup.string(),
});

function MemberProfile2(props) {
  const { activeStep, nextStep, previousStep, currentStep, getActiveStep, totalSteps, setMembership } = props;
  const initialState = {
    credentials: "",
    is_referral: true,
  };

  const [areasExpertise, setAreasExpertise] = useState([]);
  const [featuredLinks, setFeaturedLinks] = useState([]);
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const handleNextStep = () => {
    setMembership(true);
    setTimeout(() => {
      activeStep(currentStep + 1);
      nextStep();
    }, 500);
  };

  const handlePrevStep = () => {
    activeStep(getActiveStep - 1);
    previousStep();
  };

  const addExpertise = (text) => {
    setAreasExpertise((areasExpertises) => [...areasExpertises, text]);
  };
  const addFeaturedLinks = (text) => setFeaturedLinks([...featuredLinks, text]);

  const removeExpertise = (index) => {
    const newTasks = [...areasExpertise];

    newTasks.splice(index, 1);
    setAreasExpertise(newTasks);
  };

  const removeFeaturedLinks = (index) => {
    const newTasks = [...featuredLinks];

    newTasks.splice(index, 1);
    setFeaturedLinks(newTasks);
  };

  const handleSubmit = (values) => {
    setLoader(true);
    const data = {
      credentials: values.credentials,
      is_referral: values.is_referral,
      expertise: areasExpertise,
      feature: featuredLinks,
    };
    dispatch(memberProfileAction(data, props, setLoader));
  };

  return (
    <div className="pt-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8} xl={6}>
            <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
              {({ values, handleChange, handleBlur }) => {
                return (
                  <Form className="loginForm">
                    <h1 className="text-white">Setup Your Member Profile</h1>
                    <div className="accountCard">
                      <div className="mb-2">
                        <Field
                          id="credentials"
                          name="credentials"
                          className="form-control"
                          // component={TextInput}
                          value={values.credentials}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Credentials"
                        />
                      </div>
                      <div className="mb-2">
                        <AddTaskForm addTask={addExpertise} placeholder="Areas of Expertise" />
                        <ul className="todo-list mt-0">
                          {areasExpertise.map((task, index) => (
                            <li key={task} className="todo">
                              <span className="label">{task}</span>
                              <span aria-hidden className="delete" onClick={() => removeExpertise(index)}>
                                <img src={crose} alt="delete" />
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div>
                        <AddTaskForm addTask={addFeaturedLinks} placeholder="Featured Links" />
                        <ul className="todo-list mt-0">
                          {featuredLinks.map((task, index) => (
                            <li key={task} className="todo">
                              <span className="label">{task}</span>
                              <span aria-hidden className="delete" onClick={() => removeFeaturedLinks(index)}>
                                <img src={crose} alt="delete" />
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <CustomButton type="button" variant="insurance" gradient onClick={handlePrevStep}>
                        Previous
                      </CustomButton>
                      <span />
                      <button type="submit" className="nextBtn nextPrevBtn" disabled={loader}>
                        {loader ? (
                          <>
                            Sending... <SubmitLoader />
                          </>
                        ) : (
                          <CustomButton type="button" variant="insurance" gradient>
                            Next
                          </CustomButton>
                        )}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Container>

      <p className="px-4 text-white text-xl d-flex justify-content-between fw-bold mt-5">
        <span>
          Step {currentStep + 1} of {totalSteps + 1}
        </span>
        <CustomButton type="button" variant="insurance" gradient aria-hidden onClick={handleNextStep}>
          Skip For Now
        </CustomButton>
      </p>
      <div style={{ width: getActiveStep === 4 ? "100%" : "80%" }} className="signupProgressBar" />
    </div>
  );
}

export default connect(null, { memberProfileAction })(MemberProfile2);
